import { parseISO } from 'date-fns';
import { LanguageTerm } from '@app/models/language-term';
import { ChannelTerm } from '@app/models/channel-term';

export class InfoB {
  public Id: number;
  public Type: InfoBoxType;
  public Title: string;
  public ShowTitle: boolean;
  public Content?: string;
  public LinkUrl?: string;
  public LinkDescription?: string;
  public PictureUrl?: string;
  public VideoEmbedCode?: string;
  public Style: InfoBoxStyle;
  public Width: InfoBoxWidth;
  public Height: InfoBoxHeight;
  public Order: number;
  public StartDate?: string;
  public EndDate?: string;
  public StartDateAsDate?: Date;
  public EndDateAsDate?: Date;
  public CustomTextColorHexCode?: string;
  public CustomBackgroundColorHexCode?: string;
  public CustomSize?: string;
  public ChannelTermInfoBoxes: Array<ChannelTermInfoBox>;
  public LanguageTerm?: LanguageTerm;
  public LanguageTermId?: string;
  public Area: InfoBoxArea;
  public AreaId: string;
  public Route: InfoBoxRoute;
  public RouteId: string;
  public Modified: Date;
  public ModifiedBy: string;
  public CreatedBy: string;
  public Hidden: boolean;
  public TextBackgroundBanner?: string;

  constructor(opt?: Partial<InfoB>) {
    if (opt) {
      if (opt.Modified && typeof opt.Modified === 'string') {
        opt.Modified = parseISO(opt.Modified);
      }

      if (opt.StartDate && typeof opt.StartDate === 'string') {
        opt.StartDateAsDate = parseISO(opt.StartDate);
      }

      if (opt.EndDate && typeof opt.EndDate === 'string') {
        opt.EndDateAsDate = parseISO(opt.EndDate);
      }
    }

    Object.assign(this, opt);
  }
}

export interface InfoBoxArea {
  Id: string;
}

export interface InfoBoxRoute {
  Id: string;
}

export interface ChannelTermInfoBox {
  ChannelTerm: ChannelTerm;
  ChannelTermId: string;
  InfoBox: InfoB;
  InfoBoxId: number;
}

export interface LanguageTermInfoBox {
  LanguageTerm: LanguageTerm;
  LanguageTermId: string;
  InfoBox: InfoB;
  InfoBoxId: number;
}

export enum InfoBoxHeight {
  Normal = 0,
  Compact = 1,
}

export enum InfoBoxWidth {
  Auto = 0,
  Width25Percent = 25,
  Width33Percent = 33,
  Width50Percent = 50,
  Width66Percent = 66,
  Width75Percent = 75,
  Width100Percent = 100,
}

export enum InfoBoxStyle {
  None = 0,
  Accent1 = 1,
  Accent2 = 2,
  Accent3 = 3
}

export enum InfoBoxType {
  Text = 0,
  Picture = 1,
  Video = 2
}
